type OnPageDataVariables = {
  journeyStep: [null | number | string, string];
  journeyStatus: [string, string, string];
  journeyProduct: [string, string, string];
  journeyAmount: number | undefined;
  journeyProductRate: string;
  journeyProductTerm: string;
};

const runAnalytics = (callback: any): void => {
  try {
    window.runAnalytics?.(callback);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

const setInitialDataLayer = (): void => {
  runAnalytics((LBGAnalytics: any) => {
    LBGAnalytics.data
      .setPageRole('Sales')
      .setPresentation('Responsive')
      .setBrand('Lloyds')
      .setChannel('Online', undefined, undefined, false)
      .setDivision('Commercial')
      .setProduct('Cardnet', 'PSR Quote Tool')
      .setJourney('QuoteCardnetPSR', '1.0');
  });
};

const setOnPageDataLayer = ({
  journeyStep,
  journeyStatus,
  journeyProduct,
  journeyAmount,
  journeyProductRate,
  journeyProductTerm,
}: OnPageDataVariables): void => {
  runAnalytics((LBGAnalytics: any) => {
    LBGAnalytics.events.send({
      JourneyProduct: journeyProduct[0],
      JourneyTariff: journeyProduct[1],
      JourneyAddons: journeyProduct[2],
    });

    LBGAnalytics.data
      .setJourneyStep(...journeyStep)
      .setJourneyStatus(...journeyStatus)
      .setJourneyAmount(journeyAmount)
      .setJourneyRate(journeyProductRate)
      .setJourneyTerm(journeyProductTerm)
      .done()
      .events.pageView()
      .send();
  });
};

const captureFieldValue = (taggingLabel: string, value: number | string) => {
  runAnalytics((LBGAnalytics: any) => {
    LBGAnalytics.events
      .fieldUpdate(taggingLabel)
      .captureInput(taggingLabel, value)
      .send();
  });
};

export {
  captureFieldValue,
  runAnalytics,
  setInitialDataLayer,
  setOnPageDataLayer,
};
